import { LandingPage } from '@dap/memberadmin/types';

export const useSanityTranslation = (translationKey: string, language: string): LandingPage => {
  return {
    _id: '1',
    slug: `mock-${translationKey}`,
    content: [
      {
        _key: '1',
        _type: 'block',
        style: 'normal',
        markDefs: [],
        children: [{ _key: '1', _type: 'span', marks: [], text: `mock-${translationKey}` }],
      },
    ],
  };
};
